import { Button, Form, Modal, Row, message, notification } from 'antd';
import { InputFields } from 'components/common';
import React from 'react';
import { DataFormField } from 'types/models/input-field-type';
import { FIELD_TYPE } from 'types/enums';
import Icons from 'assets/icons';
import './SaveNewBCD.scss'
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import {listExamination} from 'api'
import { setAction } from 'redux/reducer/examination';
import { EXAMINATION_ACTION_TYPE } from 'types/enums/examination';
const SaveNewBCD = (props) => {
  let dispatch = useAppDispatch();
  const {open, setOpen} = props;
  const listAssign = useAppSelector(state => state.listAssign);
  const [form] = Form.useForm();
  const fields: DataFormField[] = [
    {
      label: "Tên bộ chỉ định",
      type: FIELD_TYPE.INPUT,
      name: 'tenBoChiDinh',
      css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
      rules: [{required: true, message: "Hãy nhập tên cho bộ chỉ định"}]
    },
    {
      label: "Ghi chú",
      name: "moTa",
      css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
      type: FIELD_TYPE.INPUT
    }
  ]
  const handleOk = async () => {
    form.validateFields().then(async (values) => {
      const data = {
        tenBoChiDinh: values.tenBoChiDinh,
        moTa: values.moTa,
        dmDichVuDtos: listAssign.dsChiDinh
      }
      let response = await listExamination.postBCD(data)
      if(response.status == 200) {
        setOpen(false);
        notification.success({message: "Thêm bộ chỉ định mới thành công"});
        dispatch(setAction({
          actionType: EXAMINATION_ACTION_TYPE.ADDEDNEWBCD
        }))
      }
      else {
        notification.error({message: "Lỗi khi thêm bộ chỉ đinh mới"})
      }
    }).catch(err => notification.error({message: "Lỗi khi thêm bộ chỉ định mới"}))
  }
  const handleCancel = () => {
    form.resetFields()
    setOpen(!open)
  }
  return (
    <Row className='save-new-bcd'>
      <Modal title={"Lưu bộ chỉ định mới"}
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={false}
        footer={[
          <>
            <Button icon={<Icons.close />} onClick={handleCancel}>Hủy</Button>
            <Button icon={<Icons.save />} type='primary' onClick={handleOk}>Lưu</Button>
          </>
        ]}
      >
        <Form form={form} size="large">
          <Row gutter={[0, 16]}>
            <InputFields data={fields} />
          </Row>
        </Form>
      </Modal>
    </Row>
  );
};

export default SaveNewBCD;